import React from 'react';
import { motion } from 'framer-motion';
import { RotateCcwIcon } from 'lucide-react';
import { endPage } from '../../../data/snak';
const EASE = [0.23, 1, 0.32, 1] as const;
interface EndPageProps {
  onRestart: () => void;
}
export function EndPage({
  onRestart
}: EndPageProps) {
  return <div className="relative flex flex-1 flex-col justify-center bg-deep px-12 py-9" data-id="element-162" data-mp="8qd4kqr48n41">
      <div className="grid-field pointer-events-none absolute inset-0 opacity-60" aria-hidden="true" data-id="element-163" data-mp="wgfqsq8cmyuq" />

      <div className="relative" data-id="element-164" data-mp="11fabjxpvmxhh">
        <motion.h2 initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE
      }} className="max-w-3xl font-display text-[44px] font-semibold leading-[1.0] tracking-tight text-paper" data-id="element-165" data-mp="11eh938xyau55">
          One diagnosis.
          <br data-id="element-166" data-mp="38570uiqsi93s" />
          <span className="text-mint" data-id="element-167" data-mp="384f7leko0ngo">Different morphological patterns.</span>
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.26,
        delay: 0.1,
        ease: EASE
      }} className="mt-7 max-w-2xl text-[15px] leading-relaxed text-sky/75" data-id="element-168" data-mp="3d6nzs8pprlhq">
          {endPage.support}
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.26,
        delay: 0.18,
        ease: EASE
      }} className="mt-9 border-l-2 border-mint pl-4 font-display text-[17px] text-paper" data-id="element-169" data-mp="243jyxkwv6yvw">
          {endPage.close}
        </motion.p>

        <button type="button" onClick={onRestart} className="mt-9 flex items-center gap-2 rounded-full border border-sky/25 px-4 py-2 text-[12px] font-medium text-sky/70 transition-colors duration-150 hover:border-mint/50 hover:text-mint focus:outline-none focus-visible:ring-2 focus-visible:ring-mint" data-id="element-170" data-mp="281hqgue3xx2g">
          <RotateCcwIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-171" data-mp="2rs3802nqnfp1" />
          Start a new conversation
        </button>
      </div>
    </div>;
}